export const EndOfDayIcon = ({ width = 46 }) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 67 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="0.5" width="65" height="65" rx="32.5" fill="white" />
      <rect x="1" y="0.5" width="65" height="65" rx="32.5" stroke="#916CF1" />
      <g clipPath="url(#clip0_9121_46840)">
        <path
          d="M26.1826 11.5728C27.0119 10.9379 28.1445 10.8982 29.0117 11.4536L29.1816 11.5728L41.8125 21.228C43.0422 22.1678 42.3821 24.1285 40.8379 24.1362H14.5234C13.0293 24.1287 12.3621 22.288 13.4414 21.3188L13.5518 21.228L26.1826 11.5728ZM27.6807 15.8638C27.1218 15.8638 26.5829 16.0576 26.1543 16.4087L25.9775 16.5688C25.5257 17.0206 25.2715 17.634 25.2715 18.2729C25.2716 18.8319 25.4662 19.3707 25.8174 19.7993L25.9775 19.9761C26.4293 20.4278 27.0418 20.6821 27.6807 20.6821C28.2398 20.6821 28.7793 20.4875 29.208 20.1362L29.3848 19.9761C29.8363 19.5244 30.0897 18.9117 30.0898 18.2729C30.0898 17.7137 29.8954 17.1743 29.5439 16.7456L29.3848 16.5688C28.933 16.1171 28.3196 15.8638 27.6807 15.8638Z"
          stroke="#15112D"
        />
        <path
          d="M24.5732 27.1821V35.667"
          stroke="#15112D"
          strokeLinecap="round"
        />
        <path
          d="M31.3613 27.1821V35.667"
          stroke="#15112D"
          strokeLinecap="round"
        />
        <path
          d="M38.1484 27.1821V35.667"
          stroke="#15112D"
          strokeLinecap="round"
        />
        <path
          d="M17.7852 27.1821V35.667"
          stroke="#15112D"
          strokeLinecap="round"
        />
        <path
          d="M15.5908 37.8638H39.7725C41.2526 37.8638 42.455 39.0653 42.4551 40.5454V41.1821C42.455 41.3614 42.3919 41.5339 42.2793 41.6714L42.2285 41.728C42.0836 41.8729 41.8866 41.9546 41.6816 41.9546H13.6816C13.4768 41.9545 13.2806 41.8729 13.1357 41.728C12.9909 41.5832 12.9092 41.387 12.9092 41.1821V40.5454C12.9093 39.0653 14.1107 37.8639 15.5908 37.8638Z"
          stroke="#15112D"
        />
      </g>
      <path
        d="M49.5375 31.4762C47.9135 29.8521 45.9671 28.7468 43.9044 28.1604L43.7032 28.105C44.863 32.4482 43.7393 37.2744 40.332 40.6818C36.9246 44.0892 32.0984 45.2129 27.7552 44.0531L27.7995 44.2142C28.3829 46.2918 29.492 48.2528 31.1265 49.8873C36.2105 54.9714 44.4535 54.9714 49.5375 49.8873C54.6216 44.8031 54.6216 36.5602 49.5375 31.4762Z"
        fill="white"
        stroke="url(#paint0_linear_9121_46840)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="0.451683"
        cy="0.451683"
        r="0.451683"
        transform="matrix(-1 0 0 1 49.5918 35.4824)"
        fill="#C8B5F8"
      />
      <circle
        cx="1.35505"
        cy="1.35505"
        r="1.35505"
        transform="matrix(-1 0 0 1 47.7793 34.5791)"
        fill="#C8B5F8"
      />
      <circle
        cx="2.09025"
        cy="2.09025"
        r="2.09025"
        transform="matrix(-1 0 0 1 50.498 41.8052)"
        fill="#F9BD63"
      />
      <circle
        cx="2.31521"
        cy="2.31521"
        r="2.31521"
        transform="matrix(-1 0 0 1 43.2656 47.1128)"
        fill="#C8B5F8"
      />
      <circle
        cx="0.451683"
        cy="0.451683"
        r="0.451683"
        transform="matrix(-1 0 0 1 48.6885 37.2891)"
        fill="#C8B5F8"
      />
      <circle
        cx="0.451683"
        cy="0.451683"
        r="0.451683"
        transform="matrix(-1 0 0 1 45.9727 41.8052)"
        fill="#C8B5F8"
      />
      <circle
        cx="0.451683"
        cy="0.451683"
        r="0.451683"
        transform="matrix(-1 0 0 1 45.9727 47.2261)"
        fill="#C8B5F8"
      />
      <circle
        cx="0.903366"
        cy="0.903366"
        r="0.903366"
        transform="matrix(-1 0 0 1 40.5547 43.6123)"
        fill="#C8B5F8"
      />
      <circle
        cx="0.282302"
        cy="0.282302"
        r="0.282302"
        transform="matrix(-1 0 0 1 36.041 46.7964)"
        fill="#C8B5F8"
      />
      <circle
        cx="0.451683"
        cy="0.451683"
        r="0.451683"
        transform="matrix(-1 0 0 1 51.3984 39.9995)"
        fill="#C8B5F8"
      />
      <defs>
        <linearGradient
          id="paint0_linear_9121_46840"
          x1="48.2328"
          y1="29.3849"
          x2="40.5529"
          y2="53.7004"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.406914" stopColor="#F9A01A" />
          <stop offset="1" stopColor="#7647EE" />
        </linearGradient>
        <clipPath id="clip0_9121_46840">
          <rect
            x="7.31836"
            y="6.81836"
            width="40.7273"
            height="40.7273"
            rx="7.0303"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
